import { render } from "./TipiDisegno.vue?vue&type=template&id=139642f5"
import script from "./TipiDisegno.vue?vue&type=script&lang=js"
export * from "./TipiDisegno.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__